"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapOptions = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const SwapOptions = ({ offer, state, setState, shifts, iAmCurrentlyAssigned }) => {
    const offerIsSwap = Boolean(offer?.swaps?.length);
    const _getSwapOptionLabel = (sw, shifts) => {
        const s = shifts.find(sh => sh.id === sw.shiftId);
        if (s) {
            return react_1.default.createElement("div", null, (0, moment_1.default)(s.period.start).format('dddd D.M. H:mm') + ' - ' + (0, moment_1.default)(s.period.end).format('H:mm'));
        }
        else {
            return sw.shiftId;
        }
    };
    return ((offer && offerIsSwap && !offer?.announceAction?.myReply && !iAmCurrentlyAssigned)
        ? (react_1.default.createElement("div", { className: 'ds-viewshift-row ds-viewshift-row-swaps' },
            react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('VIEW_SHIFT_SWAPS')),
            react_1.default.createElement("div", { className: 'ds-viewshift-col-value' },
                react_1.default.createElement(_ui_1.Dropdown, { label: null, singleSelect: true, size: _ui_1.Dropdown.SIZES.SMALL, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.LIGHT, options: offer.swaps?.map(sw => {
                        return {
                            value: sw.shiftId,
                            label: _getSwapOptionLabel(sw, shifts),
                        };
                    }), value: state.selectedSwap ? { value: state.selectedSwap.shiftId, label: _getSwapOptionLabel(state.selectedSwap, shifts) } : undefined, placeholder: (0, i18n_1.t)('VIEW_SHIFT_SWAPS_PLACEHOLDER'), onChange: (v) => {
                        setState(s => Object.assign({}, s, { selectedSwap: offer.swaps?.find(s => s.shiftId === v.value) }));
                    }, cb: undefined }))))
        : null);
};
exports.SwapOptions = SwapOptions;
